"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgShMenuSquare(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 12.754 12.754"
    }, props),
    React.createElement("path", { d: "M4.916 0H.93A.931.931 0 000 .93v2.391a.931.931 0 00.93.93h3.986a.931.931 0 00.93-.93V.93a.931.931 0 00-.93-.93zM4.916 5.314H.93a.931.931 0 00-.93.93v5.58a.931.931 0 00.93.93h3.986a.931.931 0 00.93-.93v-5.58a.931.931 0 00-.93-.93zM11.824 8.503H7.838a.931.931 0 00-.93.93v2.391a.931.931 0 00.93.93h3.986a.931.931 0 00.93-.93V9.433a.931.931 0 00-.93-.93zM11.824 0H7.838a.931.931 0 00-.93.93v5.58a.931.931 0 00.93.93h3.986a.931.931 0 00.93-.93V.93a.931.931 0 00-.93-.93z" })
  );
}

exports.default = SvgShMenuSquare;
module.exports = exports["default"];